import { Container, Row } from "reactstrap";
import { DetailedCourseTitle, LearningTitle } from "../../../../constants";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import BlogDetails from "./blogDetails/BlogDetails";
import LearningFilter from "../common/learningFilter";

const DetailedCourseContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={DetailedCourseTitle} parent={LearningTitle} />
      <Container fluid>
        <Row>
          <BlogDetails />
          <LearningFilter />
        </Row>
      </Container>
    </>
  );
};
export default DetailedCourseContainer;
